import { render, staticRenderFns } from "./ListarUltimasPesagens.vue?vue&type=template&id=cec102ee&scoped=true"
import script from "./ListarUltimasPesagens.vue?vue&type=script&lang=js"
export * from "./ListarUltimasPesagens.vue?vue&type=script&lang=js"
import style0 from "./ListarUltimasPesagens.vue?vue&type=style&index=0&id=cec102ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cec102ee",
  null
  
)

export default component.exports